import React, {useState, useEffect} from 'react'

const Loading = props => {
    const [show, setShow] = useState(false)
    useEffect(() => {
        setShow(props.show)
    }, [props.show])

    return show && <div className={"loading-bottom"}>Loading</div>
}

export default Loading